import React from 'react'
import { Outlet } from 'react-router'
import { Box, Heading } from '@/components/lib'

function RootDashboard () {
  return (
    <Box m={3}>
      <Heading as='h1' mb={2}>Trialflare root</Heading>
      <Outlet />
    </Box>
  )
}

export default RootDashboard
